import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";

export default function MasinaPersonalaSrlPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/masina-personala-srl-comodat")} />
      <ArticleLayout
        eyebrow="Pentru SRL"
        title="Mașina personală folosită de SRL: comodat, decont km și foaie de parcurs"
        lead="Când autoturismul e pe numele administratorului, nu al firmei, cheltuielile nu trec automat pe SRL. Fără drept de folosință documentat, bonurile de combustibil pe CUI nu țin la control."
      >
        <p>
          Dacă mașina e a persoanei fizice și o folosești în activitatea SRL-ului, ai
          nevoie mai întâi de un <strong>contract de comodat</strong> (sau un alt drept
          de folosință clar) <strong>sau</strong> de un{" "}
          <strong>decont de kilometri</strong>. Cele două nu se amestecă pe aceleași
          curse.
        </p>

        <h2>De ce foaia nu e primul document</h2>
        <p>
          Când mașina e în patrimoniul firmei, discutăm 50% vs 100% și foaie de parcurs.
          Detaliile sunt în{" "}
          <Link to="/ghid-foaie-parcurs-anaf">ghidul ANAF</Link> și în{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>.
        </p>
        <p>
          Când e <strong>înmatriculată pe persoană fizică</strong>, inspectorul întreabă
          altceva: <strong>de ce plătește firma combustibil sau service pentru un bun
          care nu e al ei?</strong> O foaie frumoasă, cu facturi pe CUI, fără contract, e
          un semnal de alarmă, nu o protecție.
        </p>

        <h2>Comodat sau decont — alege unul</h2>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Situație</th>
                <th>Ce folosești</th>
                <th>Combustibil pe CUI?</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mașina e, de fapt, mașina de serviciu a firmei</td>
                <td>Comodat + (pentru 100%) foaie și regulament</td>
                <td>Da</td>
              </tr>
              <tr>
                <td>Deplasări ocazionale (client, instanță, furnizor)</td>
                <td>Decont lei/km</td>
                <td>De regulă nu</td>
              </tr>
              <tr>
                <td>Mix personal + firmă, fără reguli</td>
                <td>Niciunul nu „spală” situația</td>
                <td>Risc de recalculare</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <strong>Comodat.</strong> Proprietarul pune mașina gratuit la dispoziția
          SRL-ului. Apoi cheltuielile pot trece pe CUI — cu aceleași limite de 50% /
          100% ca la o mașină din patrimoniu. Comodatul răspunde la „are firma dreptul
          să o folosească?”. Foaia răspunde la „a fost folosită exclusiv economic?”.
        </p>
        <p>
          <strong>Decont.</strong> Firma <strong>nu preia</strong> mașina. Persoana
          fizică merge la client, iar SRL-ul îi plătește km pe baza traseului, a sumei
          lei/km și a dovezii plății. Nu treci și alimentările pe firmă pentru aceleași
          rute: inspectorul vede dublarea. Hârtia decontului e în{" "}
          <Link to="/decont-kilometri">articolul despre decontul de kilometri</Link>.
        </p>

        <h2>Ce trebuie să existe pe hârtie</h2>
        <p>
          În contractul de comodat, minim: părțile (persoană fizică + SRL cu CUI),
          identificarea mașinii, scopul, durata, cine suportă combustibilul / RCA /
          service, cine conduce. Copie cu <strong>dată certă</strong>. Un comodat
          „semnat ieri” pentru cheltuieli de doi ani nu ajută.
        </p>
        <p>
          La decont: politica internă, traseu și scop, km, suma, dovada plății către
          persoana fizică.
        </p>
        <p>
          Dacă pretinzi <strong>100%</strong> pe cheltuielile de pe CUI: foaie de
          parcurs cu cele 4 elemente,{" "}
          <Link to="/regulament-intern-autoturism">regulament intern</Link>, bonuri corelate
          cu km. Formatul foii e același ca la o mașină din patrimoniu.
        </p>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>De evitat</strong>
          <p>
            Cheltuieli pe firmă fără comodat. Facturi de carburant pe numele persoanei
            fizice, deduse la SRL. Decont + alimentări pe aceleași km. Alimentări în
            concediu.
          </p>
        </div>
        <p>
          Pentru PFA, același principiu e în{" "}
          <Link to="/foi-parcurs-pfa">ghidul dedicat</Link>. Mai jos e calea pentru SRL.
        </p>

        <h2>Concluzie</h2>
        <p>
          Alegi <strong>un</strong> drum și îl ții până la capăt.
        </p>
        <p>
          <strong>Mașina e, de fapt, mașina de serviciu.</strong> Faci comodat cu dată
          certă. Combustibilul, RCA-ul și service-ul pot trece pe CUI. Dacă vrei 100%,
          completezi foaia lunară (cele 4 elemente) și ai regulament intern. De aici, e
          aceeași disciplină ca la o mașină din patrimoniu.
        </p>
        <p>
          <strong>Mașina e a ta, iar deplasările sunt ocazionale.</strong> Faci decont
          lei/km: traseu, scop, kilometri, dovada plății. Combustibilul rămâne al
          persoanei fizice. Foaia sau tabelul de rute arată ce curse s-au decontat.
        </p>
        <p>
          Când alegerea e făcută și hârtia e la zi, inspectorul are un răspuns simplu:
          firma folosește mașina pe drept, iar km-ii de serviciu sunt evidenți. Subiectul
          e închis. Poți trece la treabă.
        </p>
      </ArticleLayout>
    </>
  );
}
